import type { UuidText } from "@front/components/Element/Text/types";
import type { LogoUuidVectorAsset } from "@common/content/asset/vector";
import type { PropElement, PropTypes, PropDefaults } from "@platform/react-storybook/Component";
import Namespace from "../_index.scss";

export const { NAME_SPONSOR, TYPE_SPONSOR } = Namespace;

export const DURATION_SPONSOR = 15;

export type ItemSponsor = {
    uuid: string;
    text: UuidText;
    logo: LogoUuidVectorAsset;
};

export type PropSponsor = PropElement & {
    /** sponsor image list*/
    items: ItemSponsor[];
};

export const DEF_SPONSOR: PropDefaults<PropSponsor> = {};

export type PropTypesSponsor = PropTypes<PropSponsor, typeof DEF_SPONSOR>;
